/**
 * Announcement Bar — message rotation.
 * Cycles through [data-announcement-slide] elements inside [data-announcement-bar]
 * at the interval defined by the `data-interval` attribute (in ms).
 */
(function () {
  'use strict';

  const init = (bar) => {
    const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;

    const interval = Math.max(parseInt(bar.dataset.interval, 10) || 5000, 1500);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer = null;

    const show = (next) => {
      const prev = current;
      if (prev === next) return;
      slides[prev].classList.remove('is-active');
      slides[prev].classList.add('is-leaving');
      slides[next].classList.add('is-active');
      current = next;
      window.setTimeout(() => slides[prev].classList.remove('is-leaving'), 500);
    };

    const tick = () => {
      const next = (current + 1) % slides.length;
      show(next);
    };

    const start = () => {
      if (prefersReducedMotion) return;
      stop();
      timer = window.setInterval(tick, interval);
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    // Pause on hover/focus for accessibility.
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    // Pause when tab is hidden to save CPU.
    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });

    start();
  };

  const boot = () => {
    document.querySelectorAll('[data-announcement-bar]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when Shopify theme editor reloads the section.
  document.addEventListener('shopify:section:load', (e) => {
    const bar = e.target.querySelector('[data-announcement-bar]');
    if (bar) init(bar);
  });
})();
